import { __rest } from "tslib";
import clsx from 'clsx';
import { string } from 'prop-types';
import React from 'react';
import { BodyTextSmall } from '../Type';
import './PageFooter.less';
const SEPARATOR = React.createElement("span", null, "|");
const EMPTY = React.createElement("div", { role: 'presentation' });
export default function PageFooter(props) {
    const { privacyPolicyText, privacyPolicyUrl, cookiePolicyText, cookiePolicyUrl, copyrightText = `Copyright ©${new Date().getFullYear()} Kallidus Ltd`, className } = props, otherProps = __rest(props, ["privacyPolicyText", "privacyPolicyUrl", "cookiePolicyText", "cookiePolicyUrl", "copyrightText", "className"]);
    const privacyPolicyElement = privacyPolicyText ? React.createElement("a", { href: privacyPolicyUrl }, privacyPolicyText) : EMPTY;
    const cookiePolicyElement = cookiePolicyText ? React.createElement("a", { href: cookiePolicyUrl }, cookiePolicyText) : EMPTY;
    const policyElement = privacyPolicyText && cookiePolicyText ? (React.createElement("div", { className: 'kal-page-footer-policy' },
        privacyPolicyElement,
        SEPARATOR,
        cookiePolicyElement)) : (React.createElement("div", { className: 'kal-page-footer-policy' },
        privacyPolicyElement,
        cookiePolicyElement));
    return (React.createElement("div", Object.assign({ className: clsx('kal-page-footer', className) }, otherProps),
        policyElement,
        React.createElement(BodyTextSmall, { noTopSpacer: true, className: 'copyright' }, copyrightText)));
}
PageFooter.propTypes = {
    /** Used as the text of the "Privacy Policy" link */
    privacyPolicyText: string,
    /** URL destination of the "Privacy Policy" link */
    privacyPolicyUrl: string,
    /** Used as the text of the "Cookie Policy" link */
    cookiePolicyText: string,
    /** URL destination of the "Cookie Policy" link */
    cookiePolicyUrl: string,
    /** Text string for the copyright message */
    copyrightText: string,
    /** CSS class to be applied to the root */
    className: string,
};
//# sourceMappingURL=PageFooter.js.map